// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/chevron-right.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'chevron-right',
  version: 'solid',
  paths: [
    {
      d: 'M9.864 6.264a.9.9 0 0 1 1.272 0l5.1 5.1a.9.9 0 0 1 0 1.272l-5.1 5.1a.9.9 0 0 1-1.272-1.272L14.328 12 9.864 7.536a.9.9 0 0 1 0-1.272',
      fillRule: 'evenodd',
    },
  ],
}
